export const LISTING_STATUS_PRE = "pre"
export const LISTING_STATUS_PENDING = "pending"
export const LISTING_STATUS_COMPLETED = "completed"
export const LISTING_STATUS_CANCELLED = "cancelled"
export const LISTING_STATUS_ABANDONED = "abandoned"
export const LISTING_STATUS_ALLOCATED = "allocated"
export const LISTING_STATUS_ALLOCATED_JOURNEY = "allocated_journey"
export const LISTING_STATUS_ALLOCATED_INDEPENDENT = "allocated_independent"
export const LISTING_STATUS_CLICK_AND_CLAIM = "click_and_claim"
export const LISTING_STATUS_EXPIRED = "expired"
export const LISTING_STATUS_EXPRESS_INTEREST_COMPLETE = "express_interest_complete"
export const LISTING_STATUS_EXPRESS_INTEREST_PENDING = "express_interest_pending"
export const LISTING_STATUS_EXPRESS_INTEREST_PROCESSING = "express_interest_processing"
export const LISTING_STATUS_FINALISED = "finalised"
export const LISTING_STATUS_IN_REALISATION = "in_realisation"
export const LISTING_STATUS_JOURNEY_PENDING = "journey_pending"
export const LISTING_STATUS_JOURNEY_PLACED = "journey_placed"
export const LISTING_STATUS_REALISED = "realised"
export const LISTING_STATUS_SCREENING_ROOM = "screening_room"
export const LISTING_STATUS_UNDER_ANALYSIS = "under_analysis"

export const DATE_TYPE_FIXED = "fixed"
export const DATE_TYPE_FLEXIBLE = "flexible"
export const DATE_TYPE_HOURLY = "hourly"

export const FLOOR_BASEMENT = "Basement"
export const FLOOR_GROUND = "Ground floor"
export const FLOOR_1ST = "1st floor"
export const FLOOR_2ND = "2nd floor"
export const FLOOR_3RD = "3rd floor"
export const FLOOR_4TH = "4th floor"
export const FLOOR_5TH = "5th floor"
export const FLOOR_6TH = "6th floor"
export const FLOOR_ABOVE_6TH = "Above 6th floor"

export const V2_FLOOR_ABOVE_3RD = "Above 3rd floor"

export const LIFT_AVAILABLE = 1
export const LIFT_UNAVAILABLE = 0

export const FURNITURE_FLOW_MAX_CAPACITY = 4

export const V2_FLOORS = {
  [FLOOR_BASEMENT]: FLOOR_BASEMENT,
  [FLOOR_GROUND]: FLOOR_GROUND,
  [FLOOR_1ST]: FLOOR_1ST,
  [FLOOR_2ND]: FLOOR_2ND,
  [FLOOR_3RD]: FLOOR_3RD,
  [FLOOR_4TH]: V2_FLOOR_ABOVE_3RD,
  [FLOOR_5TH]: V2_FLOOR_ABOVE_3RD,
  [FLOOR_6TH]: V2_FLOOR_ABOVE_3RD,
  [FLOOR_ABOVE_6TH]: V2_FLOOR_ABOVE_3RD
}

export const LISTING_REALISED_STATUSES = [
  LISTING_STATUS_COMPLETED,
  LISTING_STATUS_ABANDONED,
  LISTING_STATUS_EXPIRED,
  LISTING_STATUS_EXPRESS_INTEREST_COMPLETE,
  LISTING_STATUS_FINALISED,
  LISTING_STATUS_IN_REALISATION,
  LISTING_STATUS_REALISED
]

export const FLOORS: OptionString[] = [
  {
    name: FLOOR_BASEMENT,
    value: FLOOR_BASEMENT
  },
  {
    name: FLOOR_GROUND,
    value: FLOOR_GROUND
  },
  {
    name: FLOOR_1ST,
    value: FLOOR_1ST
  },
  {
    name: FLOOR_2ND,
    value: FLOOR_2ND
  },
  {
    name: FLOOR_3RD,
    value: FLOOR_3RD
  },
  {
    name: FLOOR_4TH,
    value: FLOOR_4TH
  },
  {
    name: FLOOR_5TH,
    value: FLOOR_5TH
  },
  {
    name: FLOOR_6TH,
    value: FLOOR_6TH
  },
  {
    name: FLOOR_ABOVE_6TH,
    value: FLOOR_ABOVE_6TH
  }
]

export const HOUSE = "House"
export const FLAT = "Flat"
export const ONE_BED_HOUSE = "1 Bed House"
export const TWO_BED_HOUSE = "2 Bed House"
export const THREE_BED_HOUSE = "3 Bed House"
export const FOUR_BED_HOUSE = "4+ Bed House"
export const FIVE_BED_HOUSE = "5+ Bed House"
export const ONE_BED_FLAT = "1 Bed Flat"
export const TWO_BED_FLAT = "2 Bed Flat"
export const THREE_BED_FLAT = "3 Bed Flat"
export const FOUR_BED_FLAT = "4+ Bed Flat"
export const STUDIO = "Studio"
export const STORAGE = "Storage"
export const FLATSHARE = "Flatshare"

export const V2_HOUSE = "House"
export const V2_FLAT = "Flat"
export const V2_STORAGE = "Storage"
export const V2_FLATSHARE = "Room"

export const V2_PROPERTY_TYPES = {
  [ONE_BED_HOUSE]: V2_HOUSE,
  [TWO_BED_HOUSE]: V2_HOUSE,
  [THREE_BED_HOUSE]: V2_HOUSE,
  [FOUR_BED_HOUSE]: V2_HOUSE,
  [FIVE_BED_HOUSE]: V2_HOUSE,
  [ONE_BED_FLAT]: V2_FLAT,
  [TWO_BED_FLAT]: V2_FLAT,
  [THREE_BED_FLAT]: V2_FLAT,
  [FOUR_BED_FLAT]: V2_FLAT,
  [STUDIO]: V2_FLATSHARE,
  [STORAGE]: V2_STORAGE,
  [FLATSHARE]: V2_FLATSHARE
}

export const PROPERTY_TYPE_LIST_MAIN: OptionString[] = [
  {
    name: "House",
    value: HOUSE
  },
  {
    name: "Flat",
    value: FLAT
  },
  {
    name: "Studio",
    value: STUDIO
  },
  {
    name: "Storage Unit",
    value: STORAGE
  },
  {
    name: "Flatshare",
    value: FLATSHARE
  }
]

export const PROPERTY_TYPE_LIST_HOUSE: OptionString[] = [
  {
    name: "1 bed house",
    value: ONE_BED_HOUSE
  },
  {
    name: "2 bed house",
    value: TWO_BED_HOUSE
  },
  {
    name: "3 bed house",
    value: THREE_BED_HOUSE
  },
  {
    name: "4 bed house",
    value: FOUR_BED_HOUSE
  },
  {
    name: "5+ bed house",
    value: FIVE_BED_HOUSE
  }
]

export const PROPERTY_TYPE_LIST_WITH_FLOOR: OptionString[] = [
  {
    name: "1 bed flat",
    value: ONE_BED_FLAT
  },
  {
    name: "2 bed flat",
    value: TWO_BED_FLAT
  },
  {
    name: "3 bed flat",
    value: THREE_BED_FLAT
  },
  {
    name: "4+ bed flat",
    value: FOUR_BED_FLAT
  },
  {
    name: "Studio",
    value: STUDIO
  },
  {
    name: "Flatshare",
    value: FLATSHARE
  }
]

export const PROPERTY_TYPE_LIST_FLAT: OptionString[] = [
  {
    name: "1 bed flat",
    value: ONE_BED_FLAT
  },
  {
    name: "2 bed flat",
    value: TWO_BED_FLAT
  },
  {
    name: "3 bed flat",
    value: THREE_BED_FLAT
  },
  {
    name: "4+ bed flat",
    value: FOUR_BED_FLAT
  }
]

export const ITEM_IDENTIFIER_IN_PROGRESS: number = 1
export const ITEM_IDENTIFIER_HAS_ITEMS: number = 2
export const ITEM_IDENTIFIER_HAS_NO_ITEMS: number = 3
export const ITEM_IDENTIFIER_RESPONSE_ERROR: number = 4
